export function mergeUnique(currentState = {}, payload = {}) {
  const newState = { ...currentState }; // clone current state

  for (const key in payload) {
    if (key in newState) {
      // If key exists already, make an array of unique values
      newState[key] = Array.from(new Set([...newState[key], ...payload[key]]));
    } else {
      // If key doesn't exist, just assign the payload value
      newState[key] = payload[key];
    }
  }

  return newState;
}
